import Vue from 'vue'
import App from './App.vue'
import '@/assets/icon/iconfont.css'

import createRouter from "./router";
import createStore from "./store";
if (typeof window !== 'undefined') {
  const bootstrap = require('bootstrap/dist/js/bootstrap.min.js') //引用bootstrap的js
  require('@/js/validation')
  require('sweetalert2/dist/sweetalert2.min.css')
  const VueSimpleAlert = require("vue-simple-alert");
  Vue.use(VueSimpleAlert);
  // Vue.use(bootstrap);
  Vue.prototype.$bootstrap = bootstrap;
}
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.css' //引用bootstrap的样式 




import lazyload from 'vue-lazyload';
Vue.use(lazyload, {
  error: require('./assets/img/erro.jpg'),
  loading: require("./assets/img/log.gif"),
  try: 2
})
import {
  ValidationProvider
} from 'vee-validate';
// import bootstrap from 'bootstrap/dist/js/bootstrap.min.js'
import Swal from 'sweetalert2/dist/sweetalert2.js'
Vue.prototype.$swal = Swal;
// Vue.prototype.$bootstrap = bootstrap;
// import jquery from 'jquery'
Vue.config.productionTip = false


Vue.component('ValidationProvider', ValidationProvider);

// Vue.prototype.$AB = jquery
// import * as $AB from 'jquery';



import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
});

export default function createApp() {
  const router = createRouter();
  const store = createStore();
  // console.log('creat vue app');
  const app = new Vue({
    router,
    store,
    render: h => h(App)
  });
  // console.log('creat ok vue app',app);
  return {
    app,
    router,
    store
  };
}